@for (line of lines; track $index) {
  <p
    class="p1 col-11">
    @for (field of line; track $index) {
      {{ field }}
    }
  </p>
}
@if (telephone) {
  <p class="p1 m-t-10 col-11"
  >{{ telephone }}</p>
}